import React from 'react';
import PropTypes from 'prop-types';

export default function HighlightCard({ number, numberColor, title }) {
  return (
    <div className="dashboard-card dashboard-card-highlighted">
      <div className={`${numberColor} number flex-center`}>{number}</div>
      <h3 className="d-title flex-center px-3">
        {title}
      </h3>
    </div>
  );
}

HighlightCard.propTypes = {
  number: PropTypes.number.isRequired,
  numberColor: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};
